import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, FormSection, change, formValueSelector } from 'redux-form';
import { TextField, SelectField, Toggle } from 'redux-form-material-ui';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, MenuItem } from 'material-ui';
import _ from 'lodash';
import { STORE_KEYS, CAMPAIGN_FORM_KEYS, CAMPAIGN_FORM_ID, WIZZARD_FORM_ID } from 'dash-front/constants';
import { TRIGGER_PAYLOAD } from 'dash-front/triggerConstants';
import { getEntities } from 'dash-front/selectors';
import { presence } from 'dash-front/helpers/validation';

const PARAM_ADD = CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL;
// inherited from campaign
const DISABLED_PROP_TYPES_FOR_CAMPAIGN = ['tz', 'lang'];
const renderCustomField = (byTrigger, propType = {}) => {
    if (byTrigger) {
        return <span>provided by trigger</span>;
    }
    const { type, options = [] } = propType;
    let component;
    let selectOptions = [];
    switch (type) {
        case 'boolean':
            component = Toggle;
            break;
        case 'select_picker':
            component = SelectField;
            selectOptions = options.map(({ value, text }) => <MenuItem value={value} key={value} primaryText={text} />);
            break;
        default:
            component = TextField;
            break;
    }

    const isBoolean = type === 'boolean';
    const validation = propType.required ? presence : undefined;
    const parse = isBoolean ? Boolean : undefined;

    return (
        <Field parse={parse} validate={validation} component={component} name={PARAM_ADD.CUSTOM_VALUE}>
            {type === 'select_picker' ? selectOptions : null}
        </Field>
    );
};

const getCurrentWidgetPropTypesMap = (widgetId, widgets = []) => {
    const currentWidget = widgets.find(el => el.id === widgetId);
    const propTypes = _.get(currentWidget, 'spec.propTypes');

    return !Array.isArray(propTypes)
        ? {}
        : propTypes.reduce((acc, cur) => {
              acc[cur.key] = cur;
              return acc;
          }, {});
};

export class ParamsCustomizer extends React.Component {
    onKeyValueChange = index => (event, value) => {
        const {
            fields: { name }
        } = this.props;
        const { dispatch } = this.props;
        const path = name + '[' + index + '].';
        const byTrigger = value !== 'manual';
        dispatch(change(WIZZARD_FORM_ID, path + PARAM_ADD.BY_TRIGGER, byTrigger));
        if (byTrigger) {
            dispatch(change(CAMPAIGN_FORM_ID, path + PARAM_ADD.CUSTOM_VALUE, ''));
        }
    };

    renderTable = () => {
        const { fields, triggerType, values, widgetId, widgets } = this.props;
        const triggerOptions = (TRIGGER_PAYLOAD[triggerType] || []).concat(['manual']);
        const widgetPropTypes = getCurrentWidgetPropTypesMap(widgetId, widgets);

        return (
            <Table selectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn>Widget parameters</TableHeaderColumn>
                        <TableHeaderColumn>Trigger value</TableHeaderColumn>
                        <TableHeaderColumn>Value</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    {fields.map((field, index) => {
                        const prop = values[index];
                        const currentKey = prop[PARAM_ADD.KEY];
                        const widgetPropType = widgetPropTypes[currentKey];

                        if (DISABLED_PROP_TYPES_FOR_CAMPAIGN.indexOf(currentKey) !== -1) return null;
                        return (
                            // eslint-disable-next-line
                            <TableRow key={index} style={{ height: 72 }}>
                                <TableRowColumn>{currentKey}</TableRowColumn>
                                <TableRowColumn>
                                    <FormSection name={field}>
                                        <Field
                                            name={PARAM_ADD.VALUE}
                                            component={SelectField}
                                            onChange={this.onKeyValueChange(index)}
                                        >
                                            {triggerOptions.map(option => (
                                                <MenuItem key={option} value={option} primaryText={option} />
                                            ))}
                                        </Field>
                                    </FormSection>
                                </TableRowColumn>
                                <TableRowColumn>
                                    <FormSection name={field}>
                                        {renderCustomField(prop[PARAM_ADD.BY_TRIGGER], widgetPropType)}
                                    </FormSection>
                                </TableRowColumn>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        );
    };

    render() {
        return <div>{this.renderTable()}</div>;
    }
}

ParamsCustomizer.propTypes = {
    triggerType: PropTypes.string,
    values: PropTypes.array,
    widgetId: PropTypes.string,
    widgets: PropTypes.array
};

const widgetNameKey = CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + CAMPAIGN_FORM_KEYS.WIDGET.NAME;
const selector = formValueSelector(WIZZARD_FORM_ID);
const mapStateToProps = (state, { fields: { name } }) => {
    const values = selector(state, name);
    const widgetId = selector(state, widgetNameKey);
    const widgets = _.get(getEntities(state)[STORE_KEYS.WIDGET_SPECS], 'widgets');
    return { values, widgets, widgetId };
};

export default connect(mapStateToProps)(ParamsCustomizer);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/ParamsCuztomizer.js
 **/